import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import content from './sellersContent.json';
import './SellersPage.css';

export const SELLER_EMAIL = content.email;
export const SELLERS_PATH = content.path;

/** mailto: link with the submission template filled in (lib/sellersPage.js builds the same). */
export const sellerMailto = () => `mailto:${content.email}?subject=${encodeURIComponent(content.mailSubject)}&body=${encodeURIComponent(content.mailBody.join('\n'))}`;

/**
 * /sellers: how Amazon sellers submit deals. The server pre-renders this exact markup
 * (lib/sellersPage.js sellersBody) from the same sellersContent.json; keep them
 * element-for-element identical (__tests__/SellersPage.test.js checks).
 */
const SellersPage = () => {
  const c = content;
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://www.litepocketdeals.com';
  return (
    <div className="container sellers">
      {/* The server sends the same <head> (lib/sellersPage.js sellersHead), incl. structured data */}
      <Helmet>
        <title>{c.title}</title>
        <meta name="description" content={c.description} />
        <link rel="canonical" href={`${origin}${c.path}`} />
      </Helmet>
      <header className="sellers__hero">
        <p className="sellers__eyebrow">{c.eyebrow}</p>
        <h1>{c.h1}</h1>
        <p className="sellers__lead">{c.lead}</p>
        <a className="btn btn-success btn-lg sellers__cta" href={sellerMailto()}>{c.ctaLabel}</a>
        <p className="sellers__email">Or write to <a href={`mailto:${c.email}`}>{c.email}</a></p>
      </header>
      <section className="sellers__section" aria-labelledby="sellers-how">
        <h2 id="sellers-how">How it works</h2>
        <ol className="sellers__steps">
          {c.steps.map((s) => <li key={s.title}><h3>{s.title}</h3><p>{s.text}</p></li>)}
        </ol>
      </section>
      <section className="sellers__section" aria-labelledby="sellers-why">
        <h2 id="sellers-why">{c.whyTitle}</h2>
        <ul className="sellers__rules">{c.why.map((t) => <li key={t}>{t}</li>)}</ul>
      </section>
      <section className="sellers__section" aria-labelledby="sellers-rules">
        <h2 id="sellers-rules">{c.rulesTitle}</h2>
        <ul className="sellers__rules">{c.rules.map((t) => <li key={t}>{t}</li>)}</ul>
      </section>
      <section className="sellers__section" aria-labelledby="sellers-email">
        <h2 id="sellers-email">{c.templateTitle}</h2>
        <pre className="sellers__template">{c.mailBody.join('\n')}</pre>
      </section>
      <section className="sellers__section" aria-labelledby="sellers-faq">
        <h2 id="sellers-faq">{c.faqTitle}</h2>
        <dl className="sellers__faq">
          {c.faq.map((f) => <div key={f.q}><dt>{f.q}</dt><dd>{f.a}</dd></div>)}
        </dl>
      </section>
      <section className="sellers__section sellers__final">
        <h2>{c.finalTitle}</h2>
        <a className="btn btn-success btn-lg" href={sellerMailto()}>{`Email ${c.email}`}</a>
        <p><Link to="/">{c.finalLinkText}</Link></p>
        <p><Link to={c.guideLink.href}>{c.guideLink.text}</Link></p>
      </section>
    </div>
  );
};

export default SellersPage;
